import { useMemo } from 'react';
import { useLocale } from 'next-intl';
import { useSearchParams } from 'next/navigation';
import { Link, routing, usePathname } from '@/i18n/routing';

//* Components
import Text from '@/components/Text';

//* Styles
import LanguageSwitcherStyle from './style';

const LanguageSwitcher = () => {
	const pathname = usePathname();
	const selectedLang = useLocale();
	const searchParams = useSearchParams();

	const searchQuery = useMemo(() => searchParams.toString(), [searchParams]);

	const storeLanguages = useMemo(() => {
		return routing.locales.map((lang) => {
			if (selectedLang === lang) return null;

			return (
				<div
					key={lang}
					className='lang-item item-language'>
					<Link
						className='language-item'
						locale={lang}
						prefetch={false}
						href={{ pathname, query: searchQuery }}>
						<Text
							text={lang}
							suppressHydrationWarning
							className={'p2 font-montserrat-arm-medium text-primary-color text-link uppercase transition'}
						/>
					</Link>
				</div>
			);
		});
	}, [selectedLang, pathname, searchQuery]);

	return <LanguageSwitcherStyle>{storeLanguages}</LanguageSwitcherStyle>;
};

export default LanguageSwitcher;
